exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customized-radio[data-v-51298984]{margin-bottom:10px!important}", ""]);

// exports
